export const GET_SUBACOCUNT_DETAIL = "GET_SUBACOCUNT_DETAIL";
export const GET_SUBACOCUNT_DETAIL_SUCCESS = "GET_SUBACOCUNT_DETAIL_SUCCESS";
export const GET_SUBACOCUNT_DETAIL_FAILED = "GET_SUBACOCUNT_DETAIL_FAILED";

export const RESET_SUBACCOUNT_STATE = "RESET_SUBACCOUNT_STATE";
